import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Entry from 'components/Entry'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import { dateFormat, timeFormat } from 'helpers'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import Collapse from '@material-ui/core/Collapse'

const summary = (entries, delivery) => {

  if (!entries || !entries.length) {
    return { groups: [], totals: { palets: 0, boxes: 0, kg: 0 }, farmerId: null }
  }

  const groupsMap = entries.reduce((acc, entry) => {

    const greenhouse = entry.greenhouseName || 'Sin nave'
    const code = entry.code || ''
    const deliveryDate = entry.deliveryDate || ''
    const farm = entry.farmName || entry.farmId || 'Sin finca'
    const deliveryCode = entry.deliveryCode || (delivery && delivery.deliveryCode) || '';
    const groupKey = `${deliveryCode}|${code}|${farm}|${greenhouse}`;

    if (!acc[groupKey]) {
      acc[groupKey] = {
        groupKey,
        greenhouseName: greenhouse,
        code,
        deliveryCode,
        farmName: farm,
        entries: [],
        totals: { palets: 0, boxes: 0, kg: 0 }
      };
    }

    acc[groupKey].entries.push(entry);
    acc[groupKey].totals.palets += Number(entry.numPalets) || 0;
    acc[groupKey].totals.boxes += Number(entry.numBoxes) || 0;
    acc[groupKey].totals.kg += Number(entry.netWeight) || 0;

    return acc;
  }, {})

  const groups = Object.values(groupsMap)

  const totals = groups.reduce(
    (acc, group) => {
      acc.palets += group.totals.palets
      acc.boxes += group.totals.boxes
      acc.kg += group.totals.kg

      return acc;
    },
    { palets: 0, boxes: 0, kg: 0 }
  )

  return {
    groups,
    totals,
    farmerId: (delivery && delivery.farmerId),
    deliveryFarmerId: (delivery && delivery.deliveryFarmerId)
  }

}

const Delivery = props => {

  const backgroundColorClass = props.backgroundColor === 1 ? 
    props.classes.primaryDeliveryGradient : props.classes.secondaryDeliveryGradient;

  const [openGroups, setOpenGroups] = React.useState({})

  const entries = (props.delivery && props.delivery.entries) || []

  const { groups, farmerId, deliveryFarmerId } = summary(entries, props.delivery)

  const toggleGroup = (groupKey) => {
    setOpenGroups(prev => ({ ...prev, [groupKey]: !prev[groupKey] }))
  }

  return (
    <div className={backgroundColorClass}>
      <Typography className={props.classes.deliveryLabel}>
        <b className={props.classes.deliveryCode}>Albarán {props.delivery && props.delivery.deliveryCode}</b>
      </Typography>

      {groups.map(group => {
        const hasDeliveryFarmer = group.entries.some(e => e.farmerId !== e.deliveryFarmerId) && group.entries.length > 1
        const groupDeliveryFarmerId = deliveryFarmerId
        const isOpen = openGroups[group.groupKey] || false

        const groupAllInvoiced = group.entries.every(e => !!e.invoiced)
        const groupAnyNotSampled = group.entries.some(e => !e.sampled)
        const groupAllSampled = group.entries.every(e => !!e.sampled)

        const groupStatusText = groupAllInvoiced
          ? 'Liquidado'
          : (groupAnyNotSampled ? 'Pendiente de clasificar' : 'Clasificado')

        const groupStatusClass = groupAllInvoiced
          ? props.classes.invoiced
          : (groupAllSampled ? props.classes.sampled : props.classes.pending)

        const firstGroupEntry = group.entries[0] || {}
        const mainFarmerEntry = group.entries.find(e => e.farmerId !== e.deliveryFarmerId)

        if (hasDeliveryFarmer) {
          return (
            <div key={group.groupKey}>
              <div className={props.classes.groupWrapper}>
                <div className={props.classes.entry}>
                  <div className={props.classes.entryInfo}>
                    <Grid container>
                      <Grid item xs={4}>
                        <Typography className={props.classes.entryText}>Partida y Fecha</Typography>
                        <Typography className={props.classes.entryTextBold}>{firstGroupEntry.code}</Typography>
                        <Typography className={props.classes.entryTextBold}>
                          {dateFormat(firstGroupEntry.deliveryDate)} {timeFormat(firstGroupEntry.time)}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography className={props.classes.entryText}>Agricultor</Typography>
                        <Typography className={props.classes.entryTextBold}>{mainFarmerEntry.farmerName}</Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography className={props.classes.entryText}>Finca y Nave</Typography>
                        <Typography className={props.classes.entryTextBold}>
                          {firstGroupEntry.farmName}
                          <br />
                          {firstGroupEntry.greenhouseName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>

                  <div className={props.classes.entryClasification + ' ' + groupStatusClass}>
                    <Grid container>
                      <Grid item xs={4}>
                        <Typography className={props.classes.entryNumber}>
                          {group.totals.kg.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                          <span className={props.classes.entryNumberUnit}>kg.</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography className={props.classes.entryNumber}>
                          {group.totals.palets}
                          <span className={props.classes.entryNumberUnit}>palets</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography className={props.classes.entryNumber}>
                          {group.totals.boxes}
                          <span className={props.classes.entryNumberUnit}>cajas</span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>

                  <div className={props.classes.entryClasification + ' ' + groupStatusClass + ' ' + props.classes.entryClasificationHeader}>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography className={props.classes.entryClasificationStatus}>
                          { groupStatusText }
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: 'right', padding: '0 10px 5px' }}
                        onClick={() => toggleGroup(group.groupKey)}
                      >
                        <Typography>
                          <span className={props.classes.goToClasification}>
                            {isOpen ? 'Ocultar detalle' : 'Desplegar detalle'}
                            <KeyboardArrowDownIcon
                              className={props.classes.goToClasificationIcon + (isOpen ? ' ' + props.classes.arrowOpen : '')}
                              style={{ verticalAlign: 'middle' }}
                              titleAccess={isOpen ? 'Ocultar detalle' : 'Desplegar detalle'}
                              aria-label={isOpen ? 'Ocultar detalle' : 'Desplegar detalle'}
                            />
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
                <Collapse
                  in={isOpen}
                  timeout={500}
                  unmountOnExit
                  onEntering={node => { 
                    var el = node.querySelector('[data-detail-wrapper]'); 
                    el && el.classList.add(props.classes.showDetailAnimation); 
                  }}
                  onEntered={node => { 
                    var el = node.querySelector('[data-detail-wrapper]'); 
                    el && el.classList.remove(props.classes.showDetailAnimation); 
                  }}
                  onExiting={node => { 
                    var el = node.querySelector('[data-detail-wrapper]'); 
                    el && el.classList.add(props.classes.hideDetailAnimation); 
                  }}
                  onExited={node => { 
                    var el = node.querySelector('[data-detail-wrapper]'); 
                    el && el.classList.remove(props.classes.hideDetailAnimation); 
                  }}
                >
                  <div data-detail-wrapper className={props.classes.detailWrapper }>
                    <div className={props.classes.separator}>
                      <span className={props.classes.detailLabel}>Detalle</span>
                    </div>
                    <div className={props.classes.entries}>
                      {group.entries.map(entry => (
                        <Entry
                          key={entry.code || entry.id}
                          entry={entry}
                          showRole={true}
                          deliveryFarmerId={groupDeliveryFarmerId}
                          loadSampledEntryDirectAccess={props.loadSampledEntryDirectAccess}
                        />
                      ))}
                    </div>
                  </div>
                </Collapse>
            </div>
          )
        } else {
          return (
            <div key={group.groupKey} className={props.classes.groupWrapper}>
              <div className={props.classes.entries}>
                {group.entries.map(entry => (
                  <Entry
                    key={entry.code || entry.id}
                    entry={entry}
                    showRole={false}
                    deliveryFarmerId={groupDeliveryFarmerId}
                    loadSampledEntryDirectAccess={props.loadSampledEntryDirectAccess}
                  />
                ))}
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

const styles = {
  primaryDeliveryGradient: {
    background: 'linear-gradient(180deg, var(--color-entriesByProductPrimaryGradientStartColor, #7A2FF7) 0%, var(--color-entriesByProductPrimaryGradientEndColor, #C44DFF) 100%)',
  },
  secondaryDeliveryGradient: {
    background: 'linear-gradient(180deg, var(--color-entriesByProductSecondaryGradientStartColor, #C2185B) 0%, var(--color-entriesByProductSecondaryGradientEndColor, #FF4081) 100%)',
  },
  deliveryLabel: {
    padding: 10,
    color: 'white',
    fontSize: 13,
    fontWeight: 300,
  },
  deliveryCode: {
    fontWeight: 400,
  },
  entries: {
    color: 'rgb(50,50,50)',
  },
  entry: {
    margin: '10px 0',
    background: 'white',
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.17)',
    borderRadius: 4,
  },
  separator: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: 12,
    margin: '10px 0',

    '&::before, &::after': {
      content: '""',
      height: 1,
      backgroundColor: '#ccc',
      display: 'block',
    },
  },
  goToClasification: {
    background: 'white',
    color: '#000',
    fontSize: 13,
    borderRadius: 4,
    padding: '2px 1px 3px 5px',
  },
  goToClasificationIcon: {
    fontSize: 17,
    fontWeight: 300,
    verticalAlign: 'middle',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
  },
  entryInfo: {
    padding: 10,
  },
  entryText: {
    fontSize: 12,
    fontWeight: 300,
    lineHeight: '16px',
  },
  entryTextBold: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
  },
  entryNumber: {
    fontSize: 25,
    fontWeight: 500,
    color: 'white',
    textAlign: 'center',
    lineHeight: '22px',
  },
  entryNumberUnit: {
    marginLeft: 3,
    fontSize: 12,
    fontWeight: 400,
  },
  entryClasification: {
    marginTop: 1,
    padding: '8px 0 3px',
  },
  entryClasificationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 10,
    paddingRight: 10,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  entryClasificationStatus: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
  },
  arrowOpen: {
    transform: 'rotate(180deg) !important',
  },
  pending: {
    background: 'var(--color-deliveryPendingColor, #4E73B8)',
  },
  sampled: {
    background: 'var(--color-deliverySampledColor, #E3A439)',
  },
  invoiced: {
    background: 'var(--color-deliveryInvoicedColor, #8ACA4C)',
  },
  groupWrapper: {
    padding: 10,
  },
  detailWrapper: {
    padding: '5px 10px',
  },
  detailLabel: {
    color: 'white',
    fontSize: 12,
    margin: '0px 5px',
  },
  hideDetailAnimation: {
    animation: '$slideUp 500ms ease',
  },
  showDetailAnimation: {
    animation: '$slideDown 500ms ease',
  },
  '@keyframes slideDown': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-12px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)'
    }
  },
  '@keyframes slideUp': {
    '0%': {
      opacity: 1,
      transform: 'translateY(0)'
    },
    '100%': {
      opacity: 0,
      transform: 'translateY(-12px)'
    }
  }
}

export default withStyles(styles)(Delivery)



// WEBPACK FOOTER //
// ./src/components/Delivery.js